import React from "react";
import dayjs from "dayjs";
import { Invite } from "../../types/Invites";

interface InviteCardProps {
  invite: Invite;
  onShare: (invite: Invite) => void;
}

const InviteCard: React.FC<InviteCardProps> = ({ invite, onShare }) => {
  const formattedDate = dayjs(invite.createdAt).format("DD MMM YYYY, HH:mm");

  return (
    <div className="relative flex flex-col md:flex-row w-full max-w-3xl mx-auto gap-4 border border-gray-200 px-4 py-3 rounded-lg bg-white shadow-md">
      {/* Imagen */}
      <div className="w-full md:w-1/3 h-40 md:h-auto overflow-hidden rounded-md">
        <img
          src={invite.imageUrl || ""}
          alt={invite.text || "Invite image"}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.src =
              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xMDAgNzBDOTQuNDc3MiA3MCA5MCA3NC40NzcyIDkwIDgwVjEyMEM5MCA5NC40NzcyIDk0LjQ3NzIgOTAgMTAwIDkwSDEwMEMxMDUuNTIzIDkwIDExMCA5NC40NzcyIDExMCAxMjBWODBDMTEwIDc0LjQ3NzIgMTA1LjUyMyA3MCAxMDAgNzBaIiBmaWxsPSIjOUI5QkEwIi8+CjxjaXJjbGUgY3g9IjEwMCIgY3k9IjEzMCIgcj0iMjAiIGZpbGw9IiM5QjlCQTAiLz4KPC9zdmc+";
          }}
        />
      </div>

      {/* Contenido */}
      <div className="flex flex-col justify-between flex-1">
        <div className="flex flex-col gap-2">
          {invite.instructions?.meeting?.title && (
            <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
              {invite.instructions?.meeting?.title || "No Title"}
            </h3>
          )}

          {invite.text && (
            <p className="text-sm text-gray-600 line-clamp-3">{invite.text}</p>
          )}

          <p className="text-xs text-gray-400">
            {invite.createdAt ? formattedDate : "No Date"}
          </p>
        </div>

        <div className="mt-4 md:mt-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onShare(invite);
            }}
            className="w-full md:w-fit bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md flex items-center justify-center gap-2 text-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.935-2.186 2.25 2.25 0 00-3.935 2.186z"
              />
            </svg>
            <span className="hidden sm:inline">Compartir invitación</span>
            <span className="sm:hidden">Compartir</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteCard;
